// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (haystack: string, needle: string) => {
	if (!needle) return true;
	if (!haystack) return false;
	const haystackLowerCase = haystack.toLocaleLowerCase();
	const needleLowerCase = needle.toLocaleLowerCase();
	return haystackLowerCase.includes(needleLowerCase);
};
